module.exports = require('./helpers/bundle-url').getBundleURL('6bQWm') + "logo-dark.eefe0b7f.svg";